export enum IngestionPlatform {
  DOTLOOP = 'DOTLOOP',
  DOCUSIGN = 'DOCUSIGN',
  SKYSLOPE = 'SKYSLOPE',
  BROKERMINT = 'BROKERMINT',
  ZIPFORM = 'ZIPFORM',
}

export enum TransactionSide {
  BUY = 'BUY',
  SELL = 'SELL',
  BUY_SELL = 'BUY_SELL',
  UNKNOWN = 'UNKNOWN',
}

export enum NormalizedTransactionStatus {
  PRE_STAGE = 'PRE_STAGE',
  ACTIVE = 'ACTIVE',
  UNDER_CONTRACT = 'UNDER_CONTRACT',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
  PRIVATE_LISTING = 'PRIVATE_LISTING',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export enum IngestionFolderType {
  TRANSACTION = 'TRANSACTION',
  LISTING = 'LISTING',
}
